export enum LicenseFeatureLimitName {
  MAX_INTERFACES = "max_interfaces",
}
